// @mui
import { alpha, styled } from "@mui/material/styles";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
// config
import { ICON, NAVBAR } from "../../../../../config";

// ----------------------------------------------------------------------

interface StyledListItemProps {
  activeRoot?: boolean | any;
  activeSub?: boolean | any;
  subItem?: boolean | any;
}
const StyledListItem = styled(ListItemButton, {
  shouldForwardProp: (prop) =>
    prop !== "activeRoot" && prop !== "activeSub" && prop !== "subItem",
})<StyledListItemProps>(({ activeRoot, activeSub, subItem, theme }) => ({
  ...theme.typography.body2,
  position: "relative",
  height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT,
  textTransform: "capitalize",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginBottom: theme.spacing(0.5),
  color: theme.palette.text.secondary,
  borderRadius: 10,
  transition: theme.transitions.create(["background-color", "color"], {
    duration: theme.transitions.duration.shortest,
  }),
  "&:hover": {
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.common.white, 0.04)
        : alpha(theme.palette.common.black, 0.03),
  },
  // activeRoot
  ...(activeRoot && {
    ...theme.typography.subtitle2,
    fontWeight: 700,
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
    },
  }),
  // activeSub
  ...(activeSub && {
    ...theme.typography.subtitle2,
    color: theme.palette.text.primary,
  }),
  // subItem
  ...(subItem && {
    height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
  }),
}));

interface StyledListItemTextProps {
  isCollapse: boolean;
}

const StyledListItemText = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== "isCollapse",
})<StyledListItemTextProps>(({ isCollapse, theme }) => ({
  whiteSpace: "nowrap",
  transition: theme.transitions.create(["width", "opacity"], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(isCollapse && {
    width: 0,
    opacity: 0,
  }),
}));

interface StyledListItemIconProps {
  active: boolean | null;
}
const StyledListItemIcon = styled(ListItemIcon)<StyledListItemIconProps>(
  ({ active, theme }) => ({
    width: ICON.NAVBAR_ITEM,
    height: ICON.NAVBAR_ITEM,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      width: "100%",
      height: "100%",
      "& path": {
        fill: active && theme.palette.primary.main,
      },
    },
  }),
);

export { StyledListItemIcon, StyledListItemText, StyledListItem };
